import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { postAxios } from "../../Services/commonService";
import { API_POST_POSITION } from "../../utils/api/ApiConstant";

const usePosition = ({
  queryKey,
  currentPage,
  recordsPerPage,
  searchTerm,
  payload,
  refetchInterval = null,
  isAllData = false,
  refetchOnWindowFocus,
  refetchOnMount,
}) => {
  const usePositionQuery = useQuery({
    queryKey: [queryKey, payload?.server],
    queryFn: async () => {
      const res = await postAxios({
        url: API_POST_POSITION,
        payload,
      });

      return res;
    },
    refetchInterval,
    refetchOnWindowFocus,
    refetchOnMount,
  });

  // Memoized data fetching logic to handle pagination and filtering
  const fetchData = useMemo(() => {
    if (!usePositionQuery?.data) return { data: [], pages: 0 };

    if (isAllData) {
      return {
        data: usePositionQuery?.data,
        pages: 0,
      };
    } else {
      const startIndex = (currentPage - 1) * recordsPerPage;
      const endIndex = startIndex + recordsPerPage;

      const filterData = usePositionQuery?.data.filter((item) => {
        const { exchange, script } = payload;

        const matchExchange =
          exchange === "All" || item?.ExchangeName === exchange;
        const matchScript = script === "All" || item?.Script === script;

        const searchMatch =
          !searchTerm ||
          Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
          );

        return matchExchange && matchScript && searchMatch;
      });

      return {
        data: filterData.slice(startIndex, endIndex),
        pages: Math.ceil(filterData.length / recordsPerPage),
      };
    }
  }, [
    usePositionQuery?.data,
    currentPage,
    recordsPerPage,
    payload,
    searchTerm,
  ]);

  return {
    usePositionQuery,
    positionList: fetchData?.data,
    totalPages: fetchData?.pages,
  };
};

export default usePosition;
